import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import { Modal } from "@/components/modal/Modal";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useState } from "react";
import QuestionForm from "../QuestionForm";
import Title from "@/components/modal/Title";

const ModalAddQuestion = () => {
  const translate = useTranslate();
  const [isAdding, setIsAdding] = useState(false);

  const handleOnSave = () => {
    setIsAdding(true);
  };

  const handleOnClose = () => {
    setIsAdding(false);
  };

  return (
    <>
      <SecondaryButton
        onClick={handleOnSave}
        icon="plus"
        label={translate("addQuestion")}
        colour={"red"}
        size="small"
      />
      {isAdding && (
        <Modal>
          <Modal.Header>
            <Title title={translate("newQuestion")} />
          </Modal.Header>
          <Modal.Content>
            <QuestionForm onClose={handleOnClose} />
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

export default ModalAddQuestion;
